import { Component, Mixins, Prop, Ref } from 'vue-property-decorator';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import { IHypotheekdeel } from '@/model/IHypotheekdeel';
import AppHypotheekdeelModalVue from '../hypotheekdeel-modal/AppHypotheekdeelModal.vue';
import AppHypotheekdeelModal from '../hypotheekdeel-modal/AppHypotheekdeelModal';
import { Mutation } from 'vuex-class';
import { AppHypotheekMixin } from '../../mixins/AppHypotheekMixin';

@Component({
  components: {
    'app-hypotheekdeel-modal': AppHypotheekdeelModalVue
  }
})
export default class AppHypotheekdeel extends Mixins(AppFiltersMixin, AppHypotheekMixin) {
  @Prop()
  public hypotheekdeel!: IHypotheekdeel;

  @Ref('modal')
  private modal!: AppHypotheekdeelModal;
  @Mutation('hypotheken/selectCurrentHypotheekdeelnummer')
  private selectCurrentHypotheekdeelnummer!: (hypotheekdeelnummer: string) => {};

  get showAflossen(): boolean {
    return !!this.hypotheek?.canHypotheekdeelAflossen(this.hypotheekdeel, true);
  }

  get canAflossen(): boolean {
    return !!this.hypotheek?.canHypotheekdeelAflossen(this.hypotheekdeel);
  }

  get isSpaarhypotheek(): boolean {
    return this.hypotheekdeel.hypotheekvorm === 'Spaarhypotheek';
  }

  get showAflossenSpaarhypotheek(): boolean {
    return this.hypotheekdeel.isExtraAflossingToegestaan && this.isSpaarhypotheek;
  }

  public goAflossen() {
    this.selectCurrentHypotheekdeelnummer(this.hypotheekdeel.hypotheeknummer);
    this.$router.push({ name: 'aflossen-hypotheekdeel' });
  }

  public goInfoModal() {
    this.modal.show();
  }
}
